/**
 * 744 Interactive - Site Configuration
 *
 * Central source of truth for studio identity, game identity, and external links.
 * Edit this file to update branding across the entire site.
 */

export const siteConfig = {
    studioName: "744 Interactive",
    studioTagline: "Building worlds worth fighting for",

    gameName: "Expedition 744",
    gameTagline: "Survive. Build. Transform.",
    gameGenre: "Sci Fi Colony Simulation and Planetary Engineering",

    url: "https://744interactive.com",
    steamUrl: "https://store.steampowered.com/app/4428330?utm_source=landing",
    trailerUrl: "https://youtu.be/VR692S7LqqQ",

    social: {
        instagram: "https://www.instagram.com/744interactive/",
        tiktok: "https://www.tiktok.com/@744interactive",
        youtube: "https://www.youtube.com/channel/UC3tnncpEYnECgfprzUcMPlQ",
        twitter: "",
        discord: "https://discord.gg/GHZ5vpevJm",
    },

    contactEmail: "contact@744interactive.com",

    meta: {
        title: "Expedition 744 // Survive. Build. Transform Mars.",
        description:
            "Earth is dying. Expedition 744 is humanity's most ambitious planetary conversion mission. Build industry, engineer a planet, and terraform Mars. Wishlist now on Steam.",
        ogImage: "/media/header_capsule.png",
    },
} as const;
